module.exports = __webpack_public_path__ + "static/media/InProgress.0fe839d7.svg";